import { connect } from 'react-redux';
import { CANCEL_24_HOURS } from '../../products';
import { ProductCardLayoutType } from '../../common/models/product';
import { getSelected } from '../../single-choice/utils/selection';
import MainCancelTwentyFourHours from './MainCancelTwentyFourHours';
import { jsx as _jsx } from "react/jsx-runtime";
const CancelTwentyFourHours = props => {
  switch (props.layoutType) {
    case ProductCardLayoutType.Main:
    default:
      return /*#__PURE__*/_jsx(MainCancelTwentyFourHours, {
        ...props
      });
  }
};
const mapStateToProps = (state, _ref) => {
  let {
    form
  } = _ref;
  return {
    isSelected: getSelected(CANCEL_24_HOURS.name, form)(state)
  };
};
export default connect(mapStateToProps)(CancelTwentyFourHours);
//# sourceMappingURL=CancelTwentyFourHours.js.map